import { render, staticRenderFns } from "./ExtractedDetails.vue?vue&type=template&id=d36f5e62&scoped=true"
import script from "./ExtractedDetails.vue?vue&type=script&lang=js"
export * from "./ExtractedDetails.vue?vue&type=script&lang=js"
import style0 from "./ExtractedDetails.vue?vue&type=style&index=0&id=d36f5e62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36f5e62",
  null
  
)

export default component.exports